import {Location, useLocation} from 'react-router';
import {AppLocationState} from '@src/types/appLocation';

export const useLocationState = (): AppLocationState => {
  const location: Location<AppLocationState> = useLocation();
  return location.state || ({} as AppLocationState);
};
